import 'material-design-icons-iconfont/dist/material-design-icons.css';
import 'vuetify/dist/vuetify.min.css';
import VuePlyr from 'vue-plyr';
import 'vue-plyr/dist/vue-plyr.css';
import '@/css/fid.css';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import FidAuth from '@/plugins/fidauth';
import Vue from 'vue';
import Vuetify from 'vuetify';
import App from './App.vue';
import VueRouter from 'vue-router'


import {apolloProvider, persistor} from '@/js/apollo';
import {manageVersion} from '@/js/store';
import Vuex from 'vuex';
import {vxStoreInit} from './js/vxstore';
import VuejsDialog from 'vuejs-dialog';

Vue.use(VueRouter)
import router from './router';

// modify the standard themes
const vuetify = new Vuetify({
  icons: {
    iconfont: 'md',
  },
  theme: {
    dark: true,
  },
});

Vue.use(Vuetify);

// using apollo local state management, but its not working for all components - need to use vueex
Vue.use(Vuex);

// install my firebaseauth plugin
Vue.use(FidAuth);


// use the plyr.io
Vue.use(VuePlyr);

// A better dialg
Vue.use(VuejsDialog);


// restore persisted cache then render
const versionInfo = manageVersion();

const persistorPromise = versionInfo.changedVersion ? persistor.purge()
    .then(() => console.log('cleared persistent cache'))
    .then(() => {
      // just zap local state by restoring the empty persistor
      if(!versionInfo.preserveLocalState) {
        console.log('detected a change in localstate - cleared cache')
        return persistor.restore()
      }
    })
  : persistor.restore();

console.log(versionInfo);
console.log(router)
persistorPromise.then(() => {
  /* eslint-disable no-new */
  new Vue({
    router,
    store: vxStoreInit(),
    apolloProvider,
    vuetify,
    render: h => h(App),
  }).$mount('#app');
});
